import { Divider, Input } from '@heroui/react';

export const PriceRangeInput = ({
  searchParams,
  from,
  to,
  onChangeFrom,
  onChangeTo,
}: {
  searchParams?: URLSearchParams;
  from?: string;
  to?: string;
  onChangeFrom?: (value: string) => void;
  onChangeTo?: (value: string) => void;
}) => {
  return (
    <div className="flex flex-col gap-y-4 py-4">
      <p className="text-sm lg:text-base font-semibold text-[#222223]">
        Диапазон цен
      </p>
      <Divider className="-mt-1" />
      <div className="grid grid-cols-2 gap-x-4">
        <Input
          type="number"
          value={from}
          placeholder="От"
          defaultValue={searchParams?.get('price_from') || undefined}
          onValueChange={(value) => {
            searchParams?.set('price_from', value);
            onChangeFrom?.(value);
          }}
          size="lg"
          labelPlacement="inside"
        />

        <Input
          type="number"
          value={to}
          placeholder="До"
          defaultValue={searchParams?.get('price_to') || undefined}
          onValueChange={(value) => {
            searchParams?.set('price_to', value);
            onChangeTo?.(value);
          }}
          size="lg"
          labelPlacement="inside"
        />
      </div>
    </div>
  );
};
